import React, { useEffect, useRef, useState } from "react";
import { Col, Dropdown, Form, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { default as infoIcon } from "../../assets/images/infobtnblue.svg";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { apiCall } from "../../services/AxiosService";
import { commonservices } from "../../services/CommonServices";
import CKeditorComponent from "../common-component/CKeditorComponent";
import { useDispatch } from "react-redux";
import { UpdateMachine, UpdateReviewComment } from "../../services/ReduxTookit/Slice/MachineRedux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { createPortal } from "react-dom";

const Overview = ({
  getlist,
  machineId,
  handleclose,
  bindlist,
  versionlist,
  updatereviewcommentdata,
  geteditstatus,
  setmachinedetails,
}) => {
  const countFalseValues = () => {
    return Object.values(geteditstatus).filter((value) => value === false)
      .length;
  };
  const Pdfref = useRef();
  const dispatch = useDispatch();
  const [OutputSpecificationfile, setOutputSpecificationFile] = useState();
  const [InputSpecificationfile, setInputSpecificationFile] = useState();
  const [Pdffile, setPdfFile] = useState();
  const [MachineLoader, setMachineLoader] = useState(false);
  const [input, setInput] = useState({
    machineid: machineId ? machineId : 0,
    price: "",
    subcategoryid: 0,
    title: "",
    // isprivate: false,
    machinename: "",
    versionnumber: "",
    shortdescription: "",
    detaildescription: "",
    machinedocumentname: "",
    machinedocument: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: [],
    dependentmachineids: [],
    cloud: [],
    errors: {
      machineid: "",
      shortdescription: "",
      detaildescription: "",
      title: "",
      price: "",
      ValidationRules: [
        {
          FieldName: "title",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "price",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "shortdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "detaildescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setMachineLoader(true);
      let newbody = {
        machineid: versionlist?.machineid,
        versionnumber: versionlist?.number,
        booleanfield: updatereviewcommentdata?.booleanfield,
        commentfield: updatereviewcommentdata?.commentfield,
        commentfieldvalue: updatereviewcommentdata?.commentfieldvalue,
      };
      // let updateReviewResponse = await apiCall(
      //   {
      //     method: "POST",
      //     url: API_URL.BASEURL + API_URL.MACHINE.UPDATE_REVIEWR_COMMENT,
      //     body: newbody, 
      //   },
      //   true
      // );
      // let response = apiResponse(false, updateReviewResponse);

      dispatch(UpdateReviewComment(newbody))?.then((response)=>{
        if (response?.payload?.isValidate) {
          handleUpdate();
        }
        if (!response?.payload?.isValidate) {
        }
      })
     
    }
  };
  const handleUpdate = async () => {
        let body = {
      machineid: parseInt(input?.machineid),
      shortdescription: input?.shortdescription,
      detaildescription: input?.detaildescription,
      price: input?.price ? input?.price : 0,
      subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
      title: input?.title ? input?.title : "",
      cpu: input?.cpu ? input?.cpu : "",
      osrequirmet: input?.osrequirmet ? input?.osrequirmet : "",
      storage: input?.storage ? input?.storage : "",
      ram: input?.ram ? input?.ram : "",
      cloud: input?.cloud ? input?.cloud : "",
      compatiblemachineids: input?.compatiblemachineids
        ? input?.compatiblemachineids
        : "",
      dependentmachineids: input?.dependentmachineids
        ? input?.dependentmachineids
        : "",
        machinedocument: input?.machinedocument,
    };
    // if (input?.machinedocument?.size > 0) {
    //   body = { ...body, machinedocument: input?.machinedocument };
    // }
    if (countFalseValues() === 1) {
      body = { ...body, status: "In Process" };
    } else {
      body = { ...body, status: "Rejected" };
    }
     // let resData = await apiCall(
      //   {
      //     method: "PUT",
      //     url: API_URL.BASEURL + API_URL?.MACHINE?.UPDATE_MACHINE,
      //     body: body,
      //   },
      //   true
      // );
      // let response = apiResponse(true, resData, setMachineLoader);
      dispatch(UpdateMachine(body))?.then((response) => {
        if (response?.payload?.isValidate) {
          setMachineLoader(false);
          handleclose();
           // bindlist(input?.machineid);      
      const updatedMachineDetails = {
        ...getlist,
        dataList1: getlist?.dataList1?.map((item, index) => ({
          ...item,
          machinename: response?.payload?.data?.data?.machine?.machinename,
          documentpathurl: response?.payload?.data?.data?.machine?.documentpath,
        })),
        dataList2: getlist?.dataList2?.map((item) => ({
          ...item,
          detaildescription:input?.detaildescription,
          shortdescription: input?.shortdescription,
          title: input?.title,
        })),
      };
      setmachinedetails(updatedMachineDetails);
        }
        if (!response?.payload?.isValidate) {
          setMachineLoader(false);
        }
      });
    // }
  };

  const fnCommonFileChange = async (mainfile, type, tag) => {
    if (!mainfile) return;
    if (mainfile?.type !== type) {
      return toast.error(`${`Only ${type} are allowed.`}`);
    }
    setInput({
      ...input,
      [tag]: mainfile,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
    if (tag === "outputsamplefile") {
      setOutputSpecificationFile(URL.createObjectURL(mainfile));
    } else if (tag === "inputsamplefile") {
      setInputSpecificationFile(URL.createObjectURL(mainfile));
    } else if (tag === "machinedocument") {
      setPdfFile(URL.createObjectURL(mainfile));
      setInput({
        ...input,
        machinedocumentname: mainfile?.name,
        machinedocument: mainfile,
      });
    }
  };  
  const handleCKEditor = (content, tag) => {
    setInput({
      ...input,
      [tag]: content,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };
  const fnInputChange = (value, tag) => {
    if (value) {
      if (tag === "categoryid") {
        setInput({
          ...input,
          [tag]: value,
          subcategoryid: 0,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      } else {
        setInput({
          ...input,
          [tag]: value,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      }
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };

  useEffect(() => {
    if (getlist) {
      setInput({
        ...input,
        machineid: getlist?.dataList1[0]?.machineid
          ? getlist?.dataList1[0]?.machineid
          : 0,
        machinename: getlist?.dataList1[0]?.machinename
          ? getlist?.dataList1[0]?.machinename
          : "",
        versionnumber: getlist?.dataList1[0]?.versionnumber
          ? getlist?.dataList1[0]?.versionnumber
          : "",
        price: getlist?.dataList1[0]?.price ? getlist?.dataList1[0]?.price : "",
        subcategoryid: getlist?.dataList1[0]?.subcategoryid
          ? getlist?.dataList1[0]?.subcategoryid
          : 0,
        title: getlist?.dataList2[0]?.title ? getlist?.dataList2[0]?.title : "",
        shortdescription: getlist?.dataList2[0]?.shortdescription
          ? getlist?.dataList2[0]?.shortdescription
          : "",
        detaildescription: getlist?.dataList2[0]?.detaildescription
          ? getlist?.dataList2[0]?.detaildescription
          : "",
        machinedocument: getlist?.dataList1[0]?.inputsamplefileurl
          ? getlist?.dataList1[0]?.inputsamplefileurl
          : "",
        machinedocumentname: getlist?.dataList1[0]?.documentpath
          ? getlist?.dataList1[0]?.documentpath
          : "",

        // isprivate: getlist?.dataList1[0]?.isprivate
        //   ? getlist?.dataList1[0]?.isprivate
        //   : false,
        osrequirmet: getlist?.dataList2[0]?.osrequirmet
          ? getlist?.dataList2[0]?.osrequirmet
          : "",
        storage: getlist?.dataList2[0]?.storage
          ? getlist?.dataList2[0]?.storage
          : "",
        ram: getlist?.dataList2[0]?.ram ? getlist?.dataList2[0]?.ram : "",
        cpu: getlist?.dataList2[0]?.cpu ? getlist?.dataList2[0]?.cpu : "",
        cloud: getlist?.dataList2[0]?.cloud ? getlist?.dataList2[0]?.cloud : "",
        compatiblemachineids: getlist?.dataList2[0]?.compatiblemachineids
          ? getlist?.dataList2[0]?.compatiblemachineids
          : [],
        dependentmachineids: getlist?.dataList2[0]?.dependentmachineids
          ? getlist?.dataList2[0]?.dependentmachineids
          : [],
      });
    }
  }, [getlist]);

  // Add or remove 'loadtime' class based on MachineLoader

 useEffect(() => {
  if (MachineLoader) {
    document.body.classList.add('loadtime');
  } 
  // else {
  //   document.body.classList.remove('loadtime');
  // }

  // Cleanup when component unmounts
  return () => {
    document.body.classList.remove('loadtime');
  };
}, [MachineLoader]); // Re-run this effect when MachineLoader changes
const LoaderPortal = ({ children }) => {
  return createPortal(children, document.body);
};

  return (
    <div>
      {MachineLoader && (
        <LoaderPortal>
          <MainpageLoader />
        </LoaderPortal>
      )}
      <div className="machine-detail-main mt16">
        <h4 className="machine-detail-title d-flex justify-content-between align-items-center">
          <div>
            Details{" "}
            <span className="cursor-pointer">
              <img src={infoIcon} alt="information"></img>
            </span>
          </div>
          {/* <div className="d-flex justify-content-between align-items-center">
            <p className="m-0">This Machine Is ?</p>

            <Dropdown className="public-private-dropdown">
              <Dropdown.Toggle id="isprivate">
                {!input?.isprivate ? "Public" : "Private"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  className={!input?.isprivate ? "active" : ""}
                  href="#"
                  onClick={(e) =>
                    setInput({
                      ...input,
                      isprivate: false,
                    })
                  }
                >
                  <h6>Public</h6>
                  <p>
                    This machine is public, allowing all users access to run and
                    view results.
                  </p>
                </Dropdown.Item>
                <Dropdown.Item
                  className={input?.isprivate ? "active" : ""}
                  href="#"
                  onClick={(e) =>
                    setInput({
                      ...input,
                      isprivate: true,
                    })
                  }
                >
                  <h6>Private</h6>
                  <p>
                    This machine is set to private, accessible only to you for
                    secure, exclusive use.
                  </p>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
        </h4>
        <div className="machine-detail-main-body">
          <p className="machine-detail-sub-text">
            Machine configuration refers to setting and adjusting specific
            parameters or values that determine the behavior and performance of
            machines for optimal operation.
          </p>
          <Row>
            <h5 className="machine-detail-inner-title">Overview</h5>
            <Col md={6}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Machine Name<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  placeholder="Machine Name"
                  className="common-input"
                  maxLength={67}
                  value={input.machinename}
                  onChange={(e) =>
                    setInput({
                      ...input,
                      ["machinename"]: e.target.value,
                    })
                  }
                  isInvalid={input?.errors?.machinename}
                />
                {input.errors.machinename && (
                  <Form.Control.Feedback type="invalid">
                    {input.errors.machinename}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Version<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  placeholder="Version"
                  className="common-input"
                  maxLength={167}
                  value={input.versionnumber}
                  onChange={(e) =>
                    setInput({
                      ...input,
                      ["versionnumber"]: e.target.value,
                    })
                  }
                  isInvalid={input?.errors?.versionnumber}
                />
                {input.errors.versionnumber && (
                  <Form.Control.Feedback type="invalid">
                    {input.errors.versionnumber}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Title<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="title"
                    className="common-input"
                    maxLength={67}
                    value={input?.title}
                    onChange={(e) => fnInputChange(e.target.value, "title")}
                    isInvalid={input?.errors?.title}
                  />
                  {input.errors.title && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.title}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">Price</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Price"
                    className="common-input"
                    maxLength={4}
                    value={input?.price}
                    // onKeyPress={(event) => {
                    //   if (!/[0-9]/.test(event.key)) {
                    //     event.preventDefault();
                    //   }
                    // }}
                    // onChange={(e) => fnInputChange(e.target.value, "price")}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^\d*\.?\d{0,2}$/;

                      if (regex.test(value)) {
                        fnInputChange(value, "price");
                      }
                    }}
                    isInvalid={input?.errors?.price}
                  />
                  {input?.errors?.price && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.price}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="formProfilePic">
                <Form.Label className="common-label">
                  Upload Document
                </Form.Label>
                <div className="position-relative">
                  <div
                    className={`file-input height-40 ${
                      input.errors.inputsamplefile && "error-border-line"
                    }`}
                  >
                    <label
                      className="filelabel-browse-file w-100"
                      for="njnjjjnj"
                    >
                      <div className="filelabel-browse-file-inner">
                        <span>
                          {input?.machinedocumentname
                            ? input?.machinedocumentname
                            : "Pdf File"}
                        </span>
                        <div className="browse-btn-in-input">Browse</div>
                      </div>
                      <input
                        id="njnjjjnj"
                        type="file"
                        ref={Pdfref}
                        accept="application/pdf"
                        onChange={(e) =>
                          fnCommonFileChange(
                            e.target.files[0],
                            "application/pdf",
                            "machinedocument"
                          )
                        }
                      />
                    </label>
                  </div>
                  {input.errors.inputsamplefile && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.inputsamplefile}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-3" controlId="formProfilePic">
                <Form.Label className="common-label">
                  Short Description
                  <span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <div
                    className={`${
                      input.errors.shortdescription && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={handleCKEditor}
                      value={input?.shortdescription}
                      tag="shortdescription"
                    />
                  </div>
                  {input.errors.shortdescription && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.shortdescription}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formProfilePic">
                <Form.Label className="common-label">
                  Detail Description
                  <span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <div
                    className={`${
                      input.errors.detaildescription && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={handleCKEditor}
                      value={input?.detaildescription}
                      tag="detaildescription"
                    />
                  </div>
                  {input.errors.detaildescription && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={input.errors.detaildescription}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
            <div className="machin-detail-footer-btns">
              <button className="grey-btn" onClick={() => handleclose()}>
                Cancel
              </button>
              <button
                className="blue-btn"
                disabled={MachineLoader}
                onClick={(e) => updateReviewStatus(e)}
                // onClick={(e) => handleUpdate(e)}
                // type="submit"
              >
                {MachineLoader ? (
                  // <>
                  //   <span>Loading</span>{" "}
                  //   <Spinner
                  //     className="ms-1"
                  //     animation="border"
                  //     role="status"
                  //     size="sm"
                  //   >
                  //     <span className="visually-hidden">Loading...</span>
                  //   </Spinner>
                  // </>
                  <SubmitLoading />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Overview;
